var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.0503V7.94625C21.4993 7.39798 21.3896 6.85532 21.1774 6.34976C20.9652 5.84421 20.6548 5.38584 20.264 5.00125C19.4679 4.21824 18.3956 3.77999 17.279 3.78125H6.72C5.60337 3.77999 4.53109 4.21824 3.735 5.00125C3.34442 5.38592 3.03412 5.84433 2.82211 6.34988C2.61011 6.85543 2.50062 7.39805 2.5 7.94625V16.0503C2.5 17.1553 2.945 18.2143 3.736 18.9953C4.53209 19.7783 5.60437 20.2165 6.721 20.2153H17.28C18.4 20.2153 19.473 19.7753 20.265 18.9953C20.6558 18.6107 20.9662 18.1523 21.1784 17.6467C21.3906 17.1412 21.4993 16.5985 21.5 16.0503Z",
    stroke: "#FDA214",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6332 15.9673C11.6332 15.1553 11.3092 14.3773 10.7312 13.8023C10.1522 13.2264 9.36879 12.9032 8.55219 12.9032C7.73559 12.9032 6.95219 13.2264 6.37319 13.8023C6.08741 14.0857 5.86058 14.423 5.70577 14.7946C5.55096 15.1662 5.47123 15.5647 5.47119 15.9673M14.5682 8.91825H18.1622M14.5682 11.9993H16.1082M14.5682 15.0803H18.1622M8.55219 12.1393C9.09695 12.1393 9.61939 11.9228 10.0046 11.5376C10.3898 11.1524 10.6062 10.63 10.6062 10.0853C10.6062 9.5405 10.3898 9.01805 10.0046 8.63285C9.61939 8.24765 9.09695 8.03125 8.55219 8.03125C8.00744 8.03125 7.48499 8.24765 7.09979 8.63285C6.71459 9.01805 6.49819 9.5405 6.49819 10.0853C6.49819 10.63 6.71459 11.1524 7.09979 11.5376C7.48499 11.9228 8.00744 12.1393 8.55219 12.1393Z",
    stroke: "#FDA214",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageIdCard);
export default __webpack_public_path__ + "static/media/mage_id-card.8bde12c9e8d2dd4532cdb5f78f20b4c2.svg";
export { ForwardRef as ReactComponent };